export default __webpack_public_path__ + "static/media/Toys.636f99a7.svg";